export default "__VITE_ASSET__C5HQHSG5__"